import { render, staticRenderFns } from "./PersonViewer.vue?vue&type=template&id=e9278f62&"
import script from "./PersonViewer.vue?vue&type=script&lang=js&"
export * from "./PersonViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports